export const env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8787",
  PUBLIC_POSTHOG_PROJECT_TOKEN:
    import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN ?? null,
  PUBLIC_POSTHOG_HOST:
    import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? "https://us.i.posthog.com",
  TELEMETRY_DEV:
    import.meta.env.VITE_PARABLE_TELEMETRY_DEV === "1" ||
    import.meta.env.VITE_PARABLE_TELEMETRY_DEV === "true",
  TELEMETRY_DISABLED:
    import.meta.env.VITE_PARABLE_TELEMETRY_DISABLED === "1" ||
    import.meta.env.VITE_PARABLE_TELEMETRY_DISABLED === "true",
  APP_ENV:
    import.meta.env.VITE_PARABLE_APP_ENV ??
    (import.meta.env.PROD ? "production" : "development"),
  PARABLE_RELEASE_SHA:
    import.meta.env.VITE_PARABLE_RELEASE_SHA ||
    import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA ||
    import.meta.env.VERCEL_GIT_COMMIT_SHA ||
    "unknown",
} as const;
